export default {
  name: 'mainnav',
  data () {
    return {
      navVisible: false,
      activeClass: 'active'
    }
  },
  methods: {
    showNav () {
      this.navVisible = !this.navVisible
    },
    switchLocale (lang) {
      this.$i18n.locale = lang
    },
    whichOneIsActive (lang) {
      if (this.$i18n.locale === lang) {
        return true
      } else {
        return false
      }
    }
  },
  computed: {
    isNavVisible () {
      return this.navVisible
    },
    hideHamburger () {
      return this.$store.state.startSite
    }
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/components/_globals/mainnav/mainnav.js